export const HEROTYPE1 = "heroType1Block";